import { memo, PropsWithChildren } from "react";
import { cn, dayjs } from "utils";
import { recommendationMap, SignalLevel, SignalLevelType } from "../constants";
import { ohlcvUtcTime } from "../utils/ohlcvUtcTime";
import { TrendAnalysisResult } from "@/src/utils/trendAnalysisCalc";
import Translations from "@translate/components/DetailsCommon/Forecast/TechnicalSignals/SignalsSummaryDesc";
import { I18nUtil } from "@utils/i18n";
import { formatTATime } from "@/src/utils";
const I18n = I18nUtil.createScoped(Translations);
interface SignalsSummaryDescProps {
  symbol?: string;
  signalLevel?: SignalLevelType;
  signalData?: {
    buySignal: number;
    sellSignal: number;
    neutralSignal: number;
  };
  trendAnalysis?: TrendAnalysisResult;
  isStock?: boolean;
  trendUpDownResult?: "uptrend" | "downtrend";
  variant?: "timeline" | "detail" | undefined;
  textClassName?: string;
}

const SignalsSummaryDesc = ({
  signalData,
  symbol = "--",
  signalLevel = SignalLevel.NEUTRAL,
  trendAnalysis,
  isStock,
  trendUpDownResult,
  variant = "detail",
  textClassName,
}: PropsWithChildren<SignalsSummaryDescProps>) => {
  // const buySignalView = formatLightText(signalData?.buySignal);
  // const sellSignalView = formatLightText(signalData?.sellSignal);
  const buySignalView = signalData?.buySignal;
  const sellSignalView = signalData?.sellSignal;
  const totalChangePercentView = trendAnalysis?.totalChangePercent
    ? `${trendAnalysis?.totalChangePercent}%`
    : "--";

  const trendUpDownResultText =
    trendUpDownResult === "downtrend" ? I18n.t("downtrend") : I18n.t("uptrend");

  if (isStock) {
    const sinceDate =
      variant === "timeline"
        ? trendAnalysis?.startTime
          ? ohlcvUtcTime(dayjs(trendAnalysis?.startTime)).format("MMM DD, YYYY")
          : "--"
        : trendAnalysis?.startTime
          ? formatTATime(trendAnalysis?.startTime ?? 0)
          : "--";

    const textDesc = I18n.t(
      "%{var0} currently exhibits %{var1} buy signals and %{var2} sell signals. The stock has been in an %{var3} since %{var4}, with a total price change of %{var5} during this period. Overall, the technical indicators point to a %{var6} outlook for the mid-term.",
      {
        var0: symbol,
        var1: buySignalView,
        var2: sellSignalView,
        var3: trendUpDownResultText,
        var4: sinceDate,
        var5: totalChangePercentView,
        var6: recommendationMap[signalLevel as keyof typeof recommendationMap],
      },
    );
    return (
      <div
        className={cn(
          "body_output text-content_primary leading-relaxed",
          textClassName,
        )}
        dangerouslySetInnerHTML={{ __html: textDesc }}
      />
    );
  }
  const sinceDate =
    variant === "timeline"
      ? trendAnalysis?.startTime
        ? dayjs(trendAnalysis?.startTime).format("MMM DD, YYYY")
        : "--"
      : trendAnalysis?.startTime
        ? formatTATime(trendAnalysis?.startTime ?? 0)
        : "--";
  const textDesc = I18n.t(
    "%{var0} currently exhibits %{var1} buy signals and %{var2} sell signals. The token has been in an %{var3} since %{var4}, with a total price change of %{var5} during this period. Overall, the technical indicators point to a %{var6} outlook for the mid-term.",
    {
      var0: symbol,
      var1: buySignalView,
      var2: sellSignalView,
      var3: trendUpDownResultText,
      var4: sinceDate,
      var5: totalChangePercentView,
      var6: recommendationMap[signalLevel as keyof typeof recommendationMap],
    },
  );
  return (
    <div
      className={cn(
        "body_output_m text-content_primary leading-relaxed",
        textClassName,
      )}
      dangerouslySetInnerHTML={{ __html: textDesc }}
    />
  );
};

export default memo(SignalsSummaryDesc);
